import {CSSProperties, HTMLProps, ReactNode} from 'react';
import Text from './Text';
import ICON_UNCHECKED_LIGHT from '../../../public/static/v4/common/icon-check-off-light.svg';
import ICON_UNCHECKED from '../../../public/static/v4/common/icon-check-off.svg';
import ICON_CHECKED_LIGHT from '../../../public/static/v4/common/icon-check-on-light.svg';
import ICON_CHECKED from '../../../public/static/v4/common/icon-check-on.svg';
import useTheme from '../hook/useTheme';

interface IProps extends Omit<HTMLProps<HTMLInputElement>, 'label'> {
  imgChecked?: string;
  imgUnchecked?: string;
  imgWidth?: number;
  label?: string | ReactNode;
  id: string;
  additionalElement?: ReactNode;
  checkBoxStyle?: CSSProperties;
  labelDistance?: number;
  labelClassName?: string;
}

export default function CheckBoxV4({
  imgChecked,
  imgUnchecked,
  imgWidth = 18,
  label,
  className,
  id,
  additionalElement,
  checkBoxStyle,
  style,
  labelDistance = 10,
  labelClassName,
  ...rest
}: IProps) {
  const imgHeight = imgWidth;
  const isCustomLabel = typeof label !== 'string';
  const {isLightMode} = useTheme();
  return (
    <div
      className={cn('items-center flex flex-none relative', className)}
      style={checkBoxStyle}
    >
      <input
        type="checkbox"
        id={id}
        // TODO: opacity: 0으로 설정하면 outline이 보이지 않는다. 아웃라인 처리 방식이 결정되면 스타일 수정하자.
        className="cursor-pointer opacity-0 absolute z-2"
        style={{...style, width: imgWidth, height: imgHeight}}
        {...rest}
      />
      <img
        src={
          rest.checked
            ? imgChecked || (isLightMode ? ICON_CHECKED_LIGHT : ICON_CHECKED)
            : imgUnchecked ||
              (isLightMode ? ICON_UNCHECKED_LIGHT : ICON_UNCHECKED)
        }
        width={imgWidth}
        alt=""
      />
      {label && isCustomLabel && label}
      {label && !isCustomLabel && (
        <Text
          as="label"
          htmlFor={id}
          className={cn('cursor-pointer', labelClassName)}
          style={{marginLeft: `${labelDistance}px`}}
        >
          {label}
        </Text>
      )}
      {additionalElement}
    </div>
  );
}
